<template>
  <div class="log">

    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">Log Viewer</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <div class="loading-holder" v-if="!log">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="log-card mdl-card mdl-shadow--2dp" v-if="log">
      <div class="mdl-card__supporting-text log-info-bar">
        <span class="log-info">
          <span class="log-info-key">Date:</span>
          <span class="log-info-value">{{ log.date }}</span>
        </span>
        <span class="log-info">
          <span class="log-info-key">IP:</span>
          <span class="log-info-value">{{ log.ip }}</span>
        </span>
        <span class="log-info" v-if="user">
          <span class="log-info-key">User:</span>
          <span class="log-info-value">
            <router-link :to="{ name: 'user', params: { userId: user.id }}">
              <i class="material-icons user-icon">person</i>
              <span class="user-name">{{ user.display }}</span>
            </router-link>
          </span>
        </span>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand log-area">
        <div v-for="logBucket in sortedLogMessages" :key="logBucket.id" class="log-bucket">
          <div v-for="log in logBucket.logs.map(x=>JSON.parse(x))" class="log-message"
               :class="'log-type-'+log.type">
            <span class="log-timestamp">
              {{ formatTimestamp(log.timestamp) }}
            </span>
            <span class="log-content">
              <span>{{ log.type }}:</span>
              <span v-for="part in log.message">
                {{ part }}
              </span>
              <span v-if="log.type == 'timer'">
                {{ log.label }} {{ log.time }}ms
              </span>
              <div v-if="log.trace">{{ log.trace }}</div>
            </span>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from "api"
  import config from "../config"
  import moment from "moment"

  export default {
    name: 'log',
    data () {
      return {
      }
    },
    reactive: {
      log() { return ['logs','log',this.$route.params.logId] },
      logMessages() { return ['logs','logMessages',this.$route.params.logId] },
      user() { return this.log ? ['userAdmin', 'user', this.log.userId ] : null }
    },
    computed: {
      sortedLogMessages() {
        let messages = this.logMessages
        if(!messages) return []
        messages.sort((a,b) => a.timestamp - b.timestamp)
        return messages
      }
    },
    watch: {
    },
    methods: {
      formatTimestamp(timestamp) {
        return moment(timestamp).format("HH:mm:ss")
      }
    },
    created() {
    },
    beforeDestroy() {
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }

</script>

<style scoped>

  .log-card {
    width: 98%;
    margin: auto;
    margin-top: 3px;
    max-height: calc(100vh - 65px);
    display: flex;
    flex-direction: column;

  }

  .log-info-bar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-shrink: 0;
  }
  .log-info {
    display: flex;
    flex-direction: column;
    margin-left: 25px;
    margin-right: 25px;
  }
  .log-info-label {
    font-weight: bold;
  }
  .user-icon {
    vertical-align: middle;
  }

  .log-area {
    overflow-y: scroll;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
  }

  .log-bucket {
    border-top: 1px solid #dfdfdf;
  }

  .log-message {
    display: flex;
    flex-direction: row;
  }

  .log-timestamp {
    min-width: 100px;
    flex-shrink: 0;
    flex-grow: 0;
  }

  .log-type-error {
    color: red;
  }
  .log-type-info {
    color: blue;
  }

</style>



// WEBPACK FOOTER //
// Log.vue?f9ac2c72